import join from 'url-join';

import { asyncAction, createAction, http } from '../util/index';

const ordersPrefixV2 = join(import.meta.env.VITE_API2_URL, 'v1', '/orders');
const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const requestOrders = asyncAction({
  baseName: 'REQUEST_ORDERS',
  action: action => payload => dispatch => {
    dispatch(action.start());
    return http
      .post(join(ordersPrefixV2, '/search'), payload)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const requestOrderDetails = asyncAction({
  baseName: 'REQUEST_ORDER_DETAILS',
  action: action => id => dispatch => {
    dispatch(action.start());
    return http
      .get(join(ordersPrefixV2, `/detail/${id}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

const getReportStatusAndUrl = async id =>
  new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      http
        .get(join(api2, `/reports/status/${id}`))
        .then(({ data }) => {
          const { reportStatus, downloadUrl } = data;
          if (reportStatus !== 'IN PROGRESS') {
            clearInterval(interval);
            resolve(downloadUrl);
          }
        })
        .catch(error => {
          clearInterval(interval);
          reject(error);
        });
    }, 2500);
  });

export const generateOrderTrackingReport = asyncAction({
  baseName: 'GENERATE_ORDER_TRACKING_REPORT',
  action: action => payload => dispatch => {
    dispatch(action.start());
    return http
      .post(join(api2, '/reports/generateOrderTrackingReport'), payload)
      .then(async ({ data: response }) => {
        const reportId = response.id;
        const downloadUrl = await getReportStatusAndUrl(reportId);

        if (!downloadUrl) throw Error;

        const link = document.createElement('a');
        link.href = downloadUrl;
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);

        dispatch(action.success());
      })
      .catch(error => dispatch(action.error({ error })));
  }
});

export const addOrdersFilter = createAction('ADD_ORDERS_FILTER');
export const removeOrdersFilter = createAction('REMOVE_ORDERS_FILTER');
export const clearOrdersFilters = createAction('CLEAR_ORDERS_FILTERS');
export const updateOrdersDateRange = createAction('UPDATE_ORDERS_DATE_RANGE');
export const setOrdersFilters = createAction('SET_ORDERS_FILTERS');

export const updateSortBy = createAction('UPDATE_SORT_BY');
export const clearSortBy = createAction('CLEAR_SORT_BY');
export const resetPreviousLocation = createAction('RESET_PREVIOUS_LOCATION');

export const clearOrderDetails = createAction('CLEAR_ORDER_DETAILS');
export const addOrderShippingAddress = createAction('ADD_ORDER_SHIPPING_ADDRESS');

export const setOrdersTableSearch = createAction('SET_ORDERS_TABLE_SEARCH');
export const clearOrdersTableSearch = createAction('CLEAR_ORDERS_TABLE_SEARCH');

export const clearDownloadReportError = createAction('CLEAR_DOWNLOAD_REPORT_ERROR');
